import { ComponentF } from "../../ui/ui";
import Colors from "../Colors";
import {
  findActorForPosition,
  gameData,
  getItemsForPosition,
} from "../GameManager";

const withColor = (c: string, s: string) => {
  return `%c{${c}}${s}%c{}`;
};

export const TileContents: ComponentF<void> = (C) => {
  let x, y;
  if (gameData.targetFocus != null) {
    x = gameData.targetFocus.x;
    y = gameData.targetFocus.y;
  } else {
    x = gameData.player.x;
    y = gameData.player.y;
  }

  const visible = gameData.fov.get(x + y * gameData.current.width);
  const items = getItemsForPosition(x, y);
  const actor = findActorForPosition(x, y);

  if (visible) {
    const bot = C.bounds.y + C.bounds.h - 3;

    let row = C.bounds.y + 1;
    if (actor && actor != gameData.player) {
      if (row < bot) {
        row += C.display.drawText(
          C.bounds.x,
          row,
          withColor(Colors.B_GREY_4, actor.breed.name),
          C.bounds.w - 1
        );
        if (actor.breed.info && row < bot) {
          row += C.display.drawText(
            C.bounds.x,
            row,
            withColor(Colors.B_GREY_3, actor.breed.info),
            C.bounds.w - 1
          );
        }
        row += 1;
        if (actor.breed.description && row < bot) {
          row += C.display.drawText(
            C.bounds.x,
            row,
            withColor(Colors.B_GREY_2, actor.breed.description),
            C.bounds.w - 1
          );
        }
        row += 1;
      }
    }

    if (items.length) {
      items.forEach((item) => {
        if (row < bot) {
          row += C.display.drawText(
            C.bounds.x,
            row,
            withColor(Colors.B_GREY_4, item.breed.name),
            C.bounds.w - 1
          );
          if (item.breed.info && row < bot) {
            row += C.display.drawText(
              C.bounds.x,
              row,
              withColor(Colors.B_GREY_3, item.breed.info),
              C.bounds.w - 1
            );
          }
          row += 1;
          if (item.breed.description && row < bot) {
            row += C.display.drawText(
              C.bounds.x,
              row,
              withColor(Colors.B_GREY_2, item.breed.description),
              C.bounds.w - 1
            );
          }
          row += 1;
        }
      });
    }
  } else {
    C.display.drawText(C.bounds.x, C.bounds.y, "You cannot see here");
  }

  if (gameData.looking) {
    C.display.drawText(
      C.bounds.x,
      C.bounds.y + C.bounds.h - 1,
      `%c{${Colors.RED_4}}v%c{} to stop looking`,
      C.bounds.w - 1
    );
  } else {
    C.display.drawText(
      C.bounds.x,
      C.bounds.y + C.bounds.h - 1,
      `%c{${Colors.RED_4}}v%c{} to look`,
      C.bounds.w - 1
    );
  }
};
